import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Output,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'ui-grid-reset',
    templateUrl: './grid-reset.component.html',
    styleUrls: ['./grid-reset.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class UiGridResetComponent {
    @Output()
    public reset = new EventEmitter();

    public resetFilter() {
        this.reset.emit('');
    }

}
